__turbopack_context__.v({
  "category": "relatedContent-module-scss-module__NRXYUq__category",
  "image": "relatedContent-module-scss-module__NRXYUq__image",
  "imagePlaceholder": "relatedContent-module-scss-module__NRXYUq__imagePlaceholder",
  "imageWrapper": "relatedContent-module-scss-module__NRXYUq__imageWrapper",
  "imageWrapperPlaceholder": "relatedContent-module-scss-module__NRXYUq__imageWrapperPlaceholder",
  "item": "relatedContent-module-scss-module__NRXYUq__item",
  "itemTitle": "relatedContent-module-scss-module__NRXYUq__itemTitle",
  "items": "relatedContent-module-scss-module__NRXYUq__items",
  "relatedContent": "relatedContent-module-scss-module__NRXYUq__relatedContent",
  "title": "relatedContent-module-scss-module__NRXYUq__title",
});
